// import React, { useState } from "react";
// import "../styles/Whatsapp.css";

// const WhatsAppPopup = () => {
//   const [isOpen, setIsOpen] = useState(false);

//   const companyNumber = "919205936005"; // Replace with your WhatsApp number
//   const message = "Hi, I'm interested in your services.";

//   const openWhatsApp = () => {
//     const encodedMsg = encodeURIComponent(message);
//     window.open(`https://wa.me/${companyNumber}?text=${encodedMsg}`, "_blank");
//   };

//   return (
//     <div className="whatsapp-container">
//       {isOpen && (
//         <div className="whatsapp-popup">
//           <div className="popup-header">
//             <p>Need help? Chat with us on WhatsApp!</p>
//             <span onClick={() => setIsOpen(false)}>&times;</span>
//           </div>
//           <button className="chat-btn" onClick={openWhatsApp}>Start Chat</button>
//         </div>
//       )}

//       <div className="whatsapp-icon" onClick={() => setIsOpen(!isOpen)}>
//         <img src="https://img.icons8.com/color/48/000000/whatsapp.png" alt="WhatsApp Icon" />
//       </div>
//     </div>
//   );
// };

// export default WhatsAppPopup;


// components/WhatsAppPopup.js
import React, { useState } from "react";
import "../styles/Whatsapp.css";

const WhatsAppPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  const companyNumber = "919205936005"; // Use your WhatsApp number (with country code)
  const message = "Hi, I'm interested in your services.";

  const openWhatsApp = () => {
    const encodedMsg = encodeURIComponent(message);
    window.open(`https://wa.me/${companyNumber}?text=${encodedMsg}`, "_blank");
  };

  return (
    <div className="whatsapp-container">
      {isOpen && (
        <div className="whatsapp-popup">
          <div className="popup-header">
            <p>Need help? Chat with us on WhatsApp!</p>
            <span onClick={() => setIsOpen(false)}>&times;</span>
          </div>
          <button className="chat-btn" onClick={openWhatsApp}>Start Chat</button>
        </div>
      )}

      <div className="whatsapp-icon" onClick={() => setIsOpen(!isOpen)}>
        <img
          src="https://img.icons8.com/color/48/000000/whatsapp.png"
          alt="WhatsApp Icon"
        />
      </div>
    </div>
  );
};

export default WhatsAppPopup;
